import { useEffect, useLayoutEffect, useRef, useState } from "react";
import {
  motion,
  useAnimationControls,
  useInView,
  useScroll,
} from "framer-motion";

import styles from "../style/style.module.css";
import Button from "./button";

const GlobalBanner = ({
  children,
  discription,
  navLinkText,
  navLinkRoute,
  bannerImg,
  backgroundGradient,
  id,
}) => {
  const sectionRef = useRef(null);
  const [backgroundSize, setBackgroundSize] = useState(0);
  const { scrollYProgress } = useScroll({
    target: sectionRef,
    offset: ["start start", "end start"],
  });

  const isInView = useInView(sectionRef, { amount: 0.5, once: true });
  const controlls = useAnimationControls();
  //define the class in css and compare the image from the props

  const bannerAnimation = {
    hidden: {
      opacity: 0,
      x: -60,
    },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        delay: 0.4,
        duration: 0.8,
        type: "linear",
        stiffness: 180,
      },
    },
  };

  useLayoutEffect(() => {
    const unsubscribe = scrollYProgress.on("change", (e) =>
      setBackgroundSize(e),
    );
    return () => unsubscribe();
  }, [scrollYProgress]);

  useEffect(() => {
    controlls.set("hidden");
    if (isInView) {
      controlls.start("visible");
    } else {
      controlls.set("hidden");
    }
  }, [isInView, controlls, id]);

  const getFileType = (url) => {
    const extension = url.split(".").pop().toLowerCase();
    if (["jpg", "jpeg", "png", "gif", "bmp", "webp"].includes(extension)) {
      return "image";
    } else if (["mp4", "webm", "ogg", "mov"].includes(extension)) {
      return "video";
    }
    return "unknown";
  };
  const fileType = getFileType(bannerImg);

  return (
    <section
      ref={sectionRef}
      className="relative flex min-h-[calc(100vh-95.0px)] w-full shrink-0 overflow-hidden"
    >
      {fileType === "image" && (
        <img
          style={{
            height: `${100 + backgroundSize * 125}%`,
          }}
          className="absolute -z-10 h-full w-full object-cover"
          loading="lazy"
          src={bannerImg}
          alt=""
        />
      )}

      {fileType === "video" && (
        <video
          autoPlay
          loop
          muted
          style={{
            height: `${100 + backgroundSize * 125}%`,
          }}
          className="absolute -z-10 h-full w-full object-cover"
          loading="lazy"
          src={bannerImg}
        ></video>
      )}

      <div
        className={` ${backgroundGradient ? `${styles.bennerGradient}` : ""} flex w-full flex-col items-center justify-center py-20 text-white`}
      >
        <motion.div
          variants={bannerAnimation}
          initial={"hidden"}
          animate={controlls}
          style={{
            translate: `0px ${backgroundSize * 300}px`,
          }}
          className="flex h-full flex-col items-center justify-center gap-3"
        >
          <h1
            style={{
              opacity: 1 - backgroundSize * 2.5,
            }}
            className={`mb-2 text-center text-2xl text-white md:text-42 ${styles.bannerTextShadow}`}
          >
            {children}
          </h1>
          <p
            style={{
              opacity: 1 - backgroundSize * 2.5,
            }}
            className={`textAlignLastCenter mb-2 px-[5vw] text-center text-base capitalize text-white lg:text-[18px] lg:text-xl lg:leading-[26px] xl:px-[22vw] ${styles.bannerTextShadow}`}
          >
            {discription}
          </p>
          {navLinkText && (
            <div
              style={{
                opacity: 1 - backgroundSize * 2.5,
              }}
            >
              <Button
                href={navLinkRoute}
                px="px-5 text-sm text-white md:px-10 lg:px-20 lg:text-[16px] lg:leading-[26px]"
              >
                {navLinkText}
              </Button>
            </div>
          )}
        </motion.div>
      </div>
    </section>
  );
};

export default GlobalBanner;
